import React from 'react';
import "./Pages.css"
// Δεδομένα των Συντακτών
const authorsData = [
  { name: 'Vaggelis Tzimas', role: 'Admin / Author /Web Developer', category: 'Administration/Author', color: 'danger' },
  { name: 'Daria "Aeonia" Bratu', role: 'Co-Admin / Author', category: 'Administration/Author', color: 'danger' },
  { name: 'Pavlos Oranidis', role: 'Co-Admin / Web Developer', category: 'Administration/Author', color: 'danger' },
  { name: 'Rawya Ben Nasr', role: 'Author ',  color: 'warning' ,category: 'Author'},
  { name: 'Spino Aslanis', role: 'Author',  color: 'warning', category: 'Author'},
  { name: 'Rin Tzortzis', role: 'Artist , Author ', category: 'Creative', color: 'info' },
];

const TestimonialPage = () => {
  // Χρησιμοποιούμε το ίδιο σκοτεινό φόντο με την About page
  return (
    <div className="container-fluid bg-dark text-light min-vh-100 py-5">
      <div className="container my-5">
        
        {/* Κύριος Τίτλος */}
        <header className="text-center mb-5">
          <h1 className="display-4 fw-bolder mb-3 text-danger border-bottom border-danger pb-2 text-uppercase custom-metal-title">
            The Abyss Council
          </h1>
          <p className="lead text-secondary">
            Meet the Legion that fuels the Pulse of the Underground.
          </p>
        </header>

        {/* Grid για τις κάρτες των Συντακτών */}
        <div className="row g-4 justify-content-center">
          
          {authorsData.map((author, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-4 d-flex">
              {/* Bootstrap Card με custom στυλ */}
              <div className={`card bg-black text-light w-100 shadow-lg custom-author-card border border-${author.color}`}>
                
                {/* Placeholder για την εικόνα (Metal/Dark Vibe) */}
                <div className={`author-img-placeholder bg-secondary bg-opacity-10 border-bottom border-${author.color} custom-placeholder`}>
                  <i className="bi bi-person-circle display-1 text-secondary"></i>
                </div>
                
                <div className="card-body text-center p-4">
                  <h5 className="card-title fw-bold text-uppercase text-light mb-1">{author.name}</h5>
                  
                  {/* Ρόλος - Τονισμένος με το χρώμα του Bootstrap (danger/warning/info) */}
                  <p className={`card-text text-${author.color} fw-light fst-italic mb-3`}>
                    {author.role}
                  </p>
                  
                  {/* Περιγραφή (Placeholder) */}
                  <div className="text-secondary custom-bio-placeholder">
                    <p>
                    </p>
                  </div>
                  
                </div>
                {/* Footer της Κάρτας για τονίζοντας την κατηγορία */}
                <div className={`card-footer bg-${author.color} bg-opacity-25 border-0 text-uppercase fw-bold text-${author.color}`}>
                    {author.category}
                </div>
              </div>
            </div>
          ))}

        </div>
        
        {/* Footer Placeholder */}
        <section className="mt-5 pt-3 border-top border-secondary text-center text-muted">
          <p>&copy; {new Date().getFullYear()} Pulse of the Underground. Embrace the Darkness.</p>
        </section>

      </div>
    </div>
  );
};

export default TestimonialPage;